// extracted by mini-css-extract-plugin
export var changeIcon = "_5c-4";
export var container = "_5c-0";
export var divider = "_5c-7";
export var externalLinkIcon = "_5c-1";
export var green = "_5c-5";
export var helpCircleIcon = "_5c-3";
export var iconButton = "_5c-2";
export var red = "_5c-6";